import styled from 'styled-components';

const AssignButtonWrapper = styled.div`
  position: relative;
`;

export default AssignButtonWrapper;


// WEBPACK FOOTER //
// ./components/footer/assign-button/styled.js